module.exports = __webpack_public_path__ + "static/wood_inspection_0-61d43fe220cec6e2271a578e3d3c9a81.jpg";